// 리듬게임 전용 설정
export const RHYTHM_CONFIG = {
  // 리듬게임 음악 파일 경로 (난이도별로 다른 노래 설정 가능)
  RHYTHM_MUSIC: {
    easy: '/music/RhythmGame1.mp3?v=1',      // 쉬운 난이도용 노래
    normal: '/music/RhythmGame1.mp3?v=1',    // 보통 난이도용 노래  
    hard: '/music/RhythmGame1.mp3?v=1'       // 어려운 난이도용 노래 (캐시 방지)
  },

  // 예시: 난이도별로 다른 노래를 사용하고 싶다면 아래와 같이 설정
  // RHYTHM_MUSIC: {
  //   easy: '/music/easy_song.mp3',      // 쉬운 난이도용 노래
  //   normal: '/music/normal_song.mp3',  // 보통 난이도용 노래
  //   hard: '/music/hard_song.mp3'       // 어려운 난이도용 노래
  // },

  // 기본 음악 파일 (하위 호환성을 위해 유지)
  DEFAULT_MUSIC: '/music/RhythmGame1.mp3?v=1',

  // 라운드별 최대 점수
  ROUND_MAX_SCORES: {
    easy: 3000,
    normal: 3000,
    hard: 4000
  },

  // 판정 윈도우 (ms)
  JUDGMENT_WINDOWS: {
    easy: { perfect: 100, good: 200, miss: 300 },
    normal: { perfect: 90, good: 150, miss: 250 },
    hard: { perfect: 70, good: 140, miss: 200 }
  },

  // 노트 이동 시간 (ms) - BPM에 따라 동적 계산
  NOTE_TRAVEL_TIME: 2000, // 기본값 (BPM 정보가 없을 때 사용)
  
  // BPM에 따른 노트 이동 시간 계산 (2박자 분량)
  calculateNoteTravelTime: (bpm) => {
    if (!bpm || bpm <= 0) return 2000; // 기본값
    const beatDuration = 60000 / bpm; // 1박자당 ms
    return beatDuration * 2; // 2박자 분량
  },

  // 키 매핑 (e.code와 e.key 모두 지원)
  KEY_MAP: { 
    'KeyD': 0, 'd': 0,
    'KeyF': 1, 'f': 1, 
    'KeyJ': 2, 'j': 2, 
    'KeyK': 3, 'k': 3 
  },
  KEY_LABELS: ['D', 'F', 'J', 'K'],

  // 게임 종료 여유 시간 (ms)
  GAME_END_BUFFER: 5000,

  // 판정 메시지 표시 시간 (ms)
  JUDGE_MESSAGE_DURATION: 800,

  // 레인 클릭 효과 지속 시간 (ms)
  LANE_CLICK_DURATION: 100,

  // 스트럼 스타일 Miss 타임아웃 (GOOD_WINDOW 사용)
  STRUM_MISS_TIMEOUT: 'GOOD_WINDOW',
};
